module.exports = __webpack_public_path__ + "img/irose-test4-step2b.87e31dfd.png";